<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn class="ml-4" depressed outlined v-bind="attrs" v-on="on">
        {{ menuName }}
        <v-icon right>{{ mdiMenu }}</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item :key="project.id" v-for="project in projectList" @click="onClickProject(project.id)">
        <v-list-item-title class="text-center">{{ project.name }}</v-list-item-title>
      </v-list-item>
      <v-divider light v-if="hasProject" class="my-2"></v-divider>
      <v-list-item @click="onCreateProject">
        <v-list-item-title class="text-center">创建项目</v-list-item-title>
      </v-list-item>
      <v-list-item @click="onClickAccount">
        <v-list-item-title class="text-center">账号设置</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import _ from 'lodash'
import { mdiMenu } from '@mdi/js'
import { projectStore } from '@/store/project'
import { homeStore } from '@/store/home'

export default {
  name: 'ProjectMenu',
  data() {
    return { mdiMenu }
  },
  computed: {
    projectList() {
      return projectStore.list
    },
    currentProject() {
      return projectStore.current
    },
    hasProject() {
      return this.projectList.length > 0
    },
    menuName() {
      if (_.isNil(this.currentProject)) {
        return '选择项目'
      }
      return this.currentProject.name
    },
  },
  async mounted() {
    await projectStore.doLoad()
  },
  methods: {
    async onClickProject(project_id) {
      await homeStore.switchProject(project_id)
    },
    onCreateProject() {
      this.$router.push('/dash/project-detail')
    },
    onClickAccount() {
      this.$router.push('/dash/account')
    },
  },
}
</script>

<style></style>
